export default "__VITE_ASSET__DPnuUGd9__"